import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-summer-school',
  templateUrl: './summer-school.component.html',
  styleUrls: ['./summer-school.component.css']
})
export class SummerSchoolComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
